<script setup lang="ts">
import { EventListPageType } from '~/composables/types/strapiEventListPage'

definePageMeta({
  contentGroup: 'tag',
})
</script>

<template>
  <event-list-page :page-type="EventListPageType.GENERAL"></event-list-page>
</template>
